var React = require('react');

function CrossInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("line",{"id":"Cross_1","fill":"#707070","stroke":"#707070","strokeWidth":"3px","data-name":"Line 118","className":"cls-1","x2":"26","y2":"26","transform":"translate(27.061 27.061) rotate(180)","key":1}),React.createElement("line",{"id":"Cross_2","fill":"#707070","stroke":"#707070","strokeWidth":"3px","data-name":"Line 117","className":"cls-1","y1":"26","x2":"26","transform":"translate(27.061 27.061) rotate(180)","key":2})]);
}

CrossInline.defaultProps = {"width":"28.121","height":"28.121","viewBox":"0 0 28.121 28.121"};

module.exports = CrossInline;

CrossInline.default = CrossInline;
